import React from 'react';
import { notifications } from '@mantine/notifications';

export function showToast({
  title,
  message,
  color = 'teal',
  icon,
  ...rest
}: {
  title: string;
  message: React.ReactNode;
  color?: 'teal' | 'red' | 'yellow' | 'blue' | 'green' | 'gray';
  icon?: React.ReactNode;
  [key: string]: unknown;
}) {
  notifications.show({
    title,
    message,
    color,
    icon,
    style: { width: 330 },
    withBorder: true,
    autoClose: 3000,
    ...rest,
  });
}
